import React from 'react';
import { HelixLoader, PageWrapper, UpdatePageHeader } from 'components';

interface UpdateWalletsAndGroupsWrapperProps {
    title: string;
    readOnly: boolean;
    combinedLoading: boolean;
    breadCrumData: string;
    handleCancelButton: () => void;
    deleteMenuItemText: string;
    headingText: string;
    onSaveButtonClick: () => void;
    onBackArrowClick: () => void;
    handleCancelModal: () => void;
    handleCancelModalConfirmation: () => void;
    isLoading: boolean;
    isChangesUnsaved: boolean;
    openCancelModal: boolean;
    unsavedChangesConfirmationText: string;
    confirmationKey: string;
    confirmationButtonText: string;
    confirmationHeadingText: string;
    confirmationInputLabelText: string;
    confirmationSubHeadingText: React.JSX.Element;
    handleConfirmation: () => void;
    children: React.ReactNode;
}

export const UpdateWalletsAndGroupsWrapper = ({
    title,
    readOnly,
    combinedLoading,
    breadCrumData,
    handleCancelButton,
    deleteMenuItemText,
    headingText,
    onSaveButtonClick,
    onBackArrowClick,
    handleCancelModal,
    handleCancelModalConfirmation,
    isLoading,
    isChangesUnsaved,
    openCancelModal,
    unsavedChangesConfirmationText,
    confirmationKey,
    confirmationButtonText,
    confirmationHeadingText,
    confirmationInputLabelText,
    confirmationSubHeadingText,
    handleConfirmation,
    children,
}: UpdateWalletsAndGroupsWrapperProps): React.JSX.Element => {
    if (combinedLoading) {
        return <HelixLoader />;
    }

    return (
        <PageWrapper
            title={title}
            includeBreadcrumbs={true}
            breadCrumStatus='update'
            breadCrumType='Wallets_And_Groups'
            breadCrumData={breadCrumData}
            readOnly={readOnly}
            onBackArrowClick={onBackArrowClick}
        >
            <UpdatePageHeader
                headingText={headingText}
                deleteMenuItemText={deleteMenuItemText}
                handleSaveButton={onSaveButtonClick}
                handleCancelButton={handleCancelButton}
                handleCancelModal={handleCancelModal}
                handleCancelModalConfirmation={handleCancelModalConfirmation}
                isLoading={isLoading}
                readOnly={readOnly}
                isChangesUnsaved={isChangesUnsaved}
                openCancelModal={openCancelModal}
                unsavedChangesConfirmationText={unsavedChangesConfirmationText}
                confirmationModalConfig={{
                    confirmationKey: confirmationKey,
                    confirmationButtonText: confirmationButtonText,
                    confirmationHeadingText: confirmationHeadingText,
                    confirmationInputLabelText: confirmationInputLabelText,
                    handleConfirmation: handleConfirmation,
                    confirmationSubHeadingText: confirmationSubHeadingText,
                }}
            />
            {children}
        </PageWrapper>
    );
};
